import { Chip, Tooltip } from '@mui/material';

const INCLUDED_TOOLTIP =
  'This resource will be created based on the mapping done in the last step.';
const EXCLUDED_TOOLTIP =
  'This resource cannot be created because there are tags this resource depends on which were not mapped in the last step.';

export const StatusChip = ({ included }: { included: boolean }) => (
  <Tooltip title={included ? INCLUDED_TOOLTIP : EXCLUDED_TOOLTIP} arrow>
    <Chip
      size="small"
      label={included ? 'Included' : 'Excluded'}
      color={included ? 'success' : 'warning'}
      sx={{ fontWeight: 600, cursor: 'default' }}
    />
  </Tooltip>
);
